<template :key="componentKey">
  <div
    class="layout--main"
    :class="[
      layoutTypeClass,
      navbarClasses,
      footerClasses,
      { 'no-scroll': isAppPage, 'is-shop-page': isShopPage },
    ]"
  >

    <v-nav-menu
      v-if="iframe.sidebar"
      :navMenuItems="editedNavMenuItems"
      title="Vuexy"
      parent=".layout--main"
      dashboardRoute="/org-owner/notice-board"
    />

    <div
      id="content-area"
      :class="[contentAreaClass, { 'show-overlay': bodyOverlay }]"
    >
      <div id="content-overlay" />

      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal
          :navbarType="navbarType"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
        />

        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
          :navMenuItems="editedNavMenuItems"
        />
      </template>

      <template v-else>
        <the-navbar-vertical
          :navbarColor="navbarColor"
          :sidebar="iframe.sidebar"
          :showUserDropdown="iframe.userDropdown"
          :showCloseCta="iframe.closeCta"
          :class="[
            { 'text-white': isNavbarDark && !isThemeDark },
            { 'text-base': !isNavbarDark && isThemeDark },
          ]"
        />
      </template>
      <!-- /Navbar -->

      <div class="content-wrapper">
        <div :class="[!isPosPage ? 'router-view p-6' : '']">
          <div class="router-content ">
            <go-to-v2-banner />
            <setup-payment-banner v-if="showPaymentBanner"></setup-payment-banner>
            <transition :name="routerTransition">
              <div
                v-if="$route.meta.breadcrumb || $route.meta.pageTitle"
                :class="['flex flex-wrap items-center router-header hidden md:block pt-4', !isPosPage ? 'mb-6' : '']"
              >


                <!-- BREADCRUMB -->
                <vx-breadcrumb
                  class="ml-4"
                  v-if="$route.meta.breadcrumb"
                  :route="$route"
                  :isRTL="$vs.rtl"
                  :orderApprovalFlowEnabled="orderApprovalFlowEnabled"
                />

              </div>
            </transition>

            <div class="content-area__content">
              <back-to-top
                bottom="5%"
                :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'"
                visibleoffset="500"
                v-if="!hideScrollToTop && !isShopPage"
              >
                <vs-button
                  icon-pack="feather"
                  icon="icon-arrow-up"
                  class="shadow-lg btn-back-to-top"
                />
              </back-to-top>

              <transition :name="routerTransition">
                <router-view
                  @changeRouteTitle="changeRouteTitle"
                  @setAppClasses="
                    (classesStr) => $emit('setAppClasses', classesStr)
                  "
                />
              </transition>
            </div>
          </div>
        </div>
        <the-footer />
      </div>
    </div>
  </div>
</template>

<script>
import BackToTop from 'vue-backtotop';
import HNavMenu from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue';
import navMenuItems from '@/layouts/components/vertical-nav-menu/org-owner/orgOwnerNavMenuItems.js';
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue';
import TheNavbarVertical from '@/layouts/components/navbar/org-owner/TheOrgOwnerNavbarVertical.vue';
import TheFooter from '@/layouts/components/TheFooter.vue';
import themeConfig from '@/../themeConfig.js';
import { isShopRoute } from '@/utils/isShopRoute';
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue';
import _ from 'lodash';
import { mapActions, mapMutations } from 'vuex';
import OrganizationHelper from '@/mixins/Organization';
import MenuFilterHelper from '@/mixins/menuFilterMixin';
import SetupPaymentBanner from '../../components/setup-payment-banner/setupPaymentBanner.vue';
import GoToV2Banner from '../../components/go-to-v2-banner/GoToV2Banner.vue';
import { isClinicOrderApprovalFlowEnabled } from '@/globalHelpers/storeHelper';
import { INVENTORY_TEXT } from '../../../views/components/order-center/constants';
import iframeInitializationMixin from '@/mixins/iframeInitializationMixin';

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    SetupPaymentBanner,
    GoToV2Banner,
  },
  mixins: [
    OrganizationHelper,
    MenuFilterHelper,
    iframeInitializationMixin,
  ],
  provide() {
    return {
      getRoleRouteName: this.getRoleRouteName,
    };
  },
  data() {
    return {
      editedNavMenuItems: [],
      componentKey: 0,
      disableCustomizer: themeConfig.disableCustomizer,
      disableThemeTour: themeConfig.disableThemeTour,
      dynamicWatchers: {},
      footerType: themeConfig.footerType || 'static',
      hideScrollToTop: themeConfig.hideScrollToTop,
      isNavbarDark: false,
      navbarColor: themeConfig.navbarColor || '#fff',
      navbarType: themeConfig.navbarType || 'floating',
      navMenuItems: navMenuItems,
      routerTransition: themeConfig.routerTransition || 'none',
      routeTitle: this.$route.meta.pageTitle,
      steps: [
        {
          target: '#btnVNavMenuMinToggler',
          content: 'Toggle Collapse Sidebar.',
        },
        {
          target: '.vx-navbar__starred-pages',
          content:
            'Create your own bookmarks. You can also re-arrange them using drag & drop.',
        },
        {
          target: '.i18n-locale',
          content: 'You can change language from here.',
        },
        {
          target: '.navbar-fuzzy-search',
          content: 'Try fuzzy search to visit pages in flash.',
        },
        {
          target: '.customizer-btn',
          content: 'Customize template based on your preference',
          params: {
            placement: 'left',
          },
        },
        {
          target: '.vs-button.buy-now',
          content: 'Buy this awesomeness at affordable price!',
          params: {
            placement: 'top',
          },
        },
      ],
      organizationId: null,
      organization: {},
      orgOwnerPermission: null,
      userId: null,
      iframe: {
        sidebar: true,
        navbar: true,
        userDropdown: true,
        footer: true,
      },
      orderApprovalFlowEnabled: null,
    };
  },
  watch: {
    $route() {
      this.routeTitle = this.$route.meta.pageTitle;
    },
    isThemeDark(val) {
      const color = this.navbarColor == '#fff' && val ? '#10163a' : '#fff';
      this.updateNavbarColor(color);
    },
    '$store.state.mainLayoutType'(val) {
      this.setNavMenuVisibility(val);
      this.disableThemeTour = true;
    },
  },
  computed: {
    isShopPage() {
      return isShopRoute(this.$route && this.$route.path);
    },
    isPosPage() {
      return this.$route.name === 'OrgOwnerPOS';
    },
    showPaymentBanner() {
      return process.env.VUE_APP_REGION == 'US';
    },
    bodyOverlay() {
      return this.$store.state.bodyOverlay;
    },
    contentAreaClass() {
      // If sidebar is hidden in iframe mode, use full width
      if (!this.iframe.sidebar) {
        return 'content-area-full';
      }

      if (this.mainLayoutType === 'vertical') {
        if (this.verticalNavMenuWidth == 'default')
          return 'content-area-reduced';
        else if (this.verticalNavMenuWidth == 'reduced')
          return 'content-area-lg';
        else return 'content-area-full';
      }
      else return 'content-area-full';
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      };
    },
    isAppPage() {
      return this.$route.meta.no_scroll;
    },
    isThemeDark() {
      return this.$store.state.theme == 'dark';
    },
    layoutTypeClass() {
      return `main-${this.mainLayoutType}`;
    },
    mainLayoutType() {
      return this.$store.state.mainLayoutType;
    },
    navbarClasses() {
      return {
        'navbar-hidden': this.navbarType == 'hidden',
        'navbar-sticky': this.navbarType == 'sticky',
        'navbar-static': this.navbarType == 'static',
        'navbar-floating': this.navbarType == 'floating',
      };
    },
    verticalNavMenuWidth() {
      return this.$store.state.verticalNavMenuWidth;
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
  },
  async mounted() {
    const clinicId = sessionStorage.getItem('doctorClinicSelectedClinic');

    try {
      this.orderApprovalFlowEnabled = await isClinicOrderApprovalFlowEnabled(clinicId);
    } catch (error) {
      console.error('Error fetching clinic details:', error);
      this.orderApprovalFlowEnabled = false;
    }
  },
  async beforeMount() {
    this.init();
    this.userId = JSON.parse(localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`))._id;
    if (
      localStorage.getItem(
        `${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`
      )
    ) {
      this.organizationId = localStorage.getItem(
        `${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`
      );
      this.organization = _.find(
        JSON.parse(
          localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)
        ).organizations,
        ['_id', this.organizationId]
      );
    }
  },

  methods: {
    ...mapActions('organization', ['fetchOrganizationClinicsList', 'fetchOrganizationUser']),
    ...mapActions('admin', ['fetchUserPermission', 'checkPOSEnabledClinicsFromOrg']),
    ...mapMutations(['SHOW_STORE']),

    async init() {
      const clinics = await this.getOrganizationAllowedClinics();
      const organizationStatus = await this.getOrganizationComplianceStatus();
      const isComplianceEnabled = organizationStatus.isMonthlyComplianceEnabled;
      const isDrugbookEnabled = organizationStatus.isDrugbookEnabled;
      const isAnalyticsEnabled = organizationStatus.isAnalyticsEnabled;
      const hasDrugEntry = await this.checkClinicDrugEntry();
      let hide = [
        'Dashboard',
        'Events',
        'Resources',
        'Compliance',
        'Insights',
        'Consent Forms',
        'POS',
      ];
      const { data: permission } = await this.fetchUserPermission({
        userId: this.userId,
        organizationId: this.organizationId,
      });
      const {data: hasPOSEnabledClinics} = await this.checkPOSEnabledClinicsFromOrg({organizationId: this.organizationId});
      const hasConsentQuestionPermi = _.find(permission, (permi) => permi.permission.name === 'CustomConsentForm');
      this.editedNavMenuItems = _.pull(
        _.cloneDeep(this.navMenuItems).map((item) => {
          /**
           * Scenario for showing POS in nav.
           * 1. If POS is enabled for an org-owner and
           * a clinic in the organization has POS enabled,
           * POS menu will show in their account.
           * 2. If POS is enabled for an org-owner but
           * there's no POS enabled clinics in the organization,
           * POS will be hidden in the nav.
           * 3. If POS is disabled for an org-owner and
           * a clinic in the organization has POS enabled,
           * POS wil be hidden in the nav.
           */
          if (item.name === 'POS'){
            if (_.find(permission, (permi) => permi.permission.name === 'POS') && hasPOSEnabledClinics.data) {
              return item;
            }
            return;
          }

          if (['Shop','My Orders','Products'].includes(item.name) && this.orderApprovalFlowEnabled) {
            return {...item, i18n: INVENTORY_TEXT[item.name]};
          }

          if (item.name === 'Insights'){
            if (_.find(permission, (permi) => permi.permission.name === 'Insights') == undefined && isAnalyticsEnabled) {
              return;
            }
          }
          if (item.name === 'nurse-dashboard'){
            if (_.find(permission, (permi) => permi.permission.name === 'Insights') == undefined && isAnalyticsEnabled) {
              return item;
            } else if (_.find(permission, (permi) => permi.permission.name === 'Insights') && isAnalyticsEnabled) {
              return;
            } else if (!isAnalyticsEnabled){
              return;
            }
          }
          /**
           * CustomConsentForm permission checker [US]
           * If enabled, show
           * then if disabled, hide
           */
          if (item.name === 'Consent Forms') {
            if (hasConsentQuestionPermi) return item;
            return;
          }

          if (item.header === 'Settings') {
            if (!hasConsentQuestionPermi) {
              item.items = item.items.filter((item) => item.name !== 'Consent Forms');
            }

            /**
             * 1. If the user is NOT a Doc EMR and has a custom product list - revoke access to the product list.
             * 2. If the user is a Doc EMR and has a custom product list - allow access.
             * 3. If the user is a Doc EMR and does NOT have a custom product list - always allow access.
             * 4. If the user is NOT a Doc EMR and does NOT have a custom product list - display the product list.
             */

            // Define menu item names dynamically based on user type
            const customProductListName = 'OrgOwner Custom Products List';
            const productListName = 'OrgOwner Products List';

            const removeMenuItem = (menu, itemName) => {
              // Find the index of the item with the specified name
              const index = menu.items.findIndex((child) => child.name === itemName);
              // If the item exists, remove it from the array
              if (index !== -1) {
                menu.items.splice(index, 1);
              }
            };
            // Remove the appropriate menu item based on the user's Doc EMR status
            removeMenuItem(item, this.isDoctorEMR() ? productListName : customProductListName);

          }
          if (process.env.VUE_APP_REGION === 'US') {
            // Show dashboard & resources
            const dashboardIndex = hide.indexOf('Dashboard');
            const resourceIndex = hide.indexOf('Resources');
            hide.splice(dashboardIndex, 1);
            hide.splice(resourceIndex, 1);

            // Hide inventory, drugbook, clinics, staff & invoices
            hide.push('Inventory', 'Drugbook', 'org-ownerClinics', 'Staff', 'Invoice Management');
            if (
              (item.name === 'Insights' && !isAnalyticsEnabled)
            ) {
              return;
            } else if (_.indexOf(hide, item.name) === -1) {
              return item;
            }
            return;
          } else if (process.env.VUE_APP_REGION === 'AU') {
            if (item.name === 'Dispense Request' && !this.$store.getters['organization/selectedOrganizationActiveModels'].includes('model 3')) {
              return;
            }

            if (item.header === 'Compliance') {
              const hideComplianceMenu = !isComplianceEnabled || !this.$store.getters['organization/isComplianceVisible'];

              if (hideComplianceMenu) {
                item.items = item.items.filter((item) => item.name !== 'Compliance');
              }

              if (
                !(isDrugbookEnabled && hasDrugEntry) &&
                !(isDrugbookEnabled && !hasDrugEntry) &&
                !(!isDrugbookEnabled && hasDrugEntry)
              ) {
                item.items = item.items.filter((item) => !['Drugbook', 'Inventory'].includes(item.name));
              }


              //Hide Compliance nav if sub menu is empty
              if(item.items.length === 0) {
                return;
              }
            }
            /**
             * Setting permi checker
             * - Consent form
             * - Aftercare docs [AU]
             * - Product list
             * - Custom Product list
             */

            if (item.name === 'Insights' && !isAnalyticsEnabled) {
              return;
            }
          }
          // offboarded clinics
          if(!clinics.length && (this.hideMenu.name.includes(item.name) || this.hideMenu.header.includes(item.header))) {
            return;
          }
          return item;
        }),
        undefined
      );
    },

    changeRouteTitle(title) {
      this.routeTitle = title;
    },
    updateNavbar(val) {
      if (val == 'static')
        this.updateNavbarColor(this.isThemeDark ? '#10163a' : '#fff');
      this.navbarType = val;
    },
    updateNavbarColor(val) {
      this.navbarColor = val;
      if (val == '#fff') this.isNavbarDark = false;
      else this.isNavbarDark = true;
    },
    updateFooter(val) {
      this.footerType = val;
    },
    updateRouterTransition(val) {
      this.routerTransition = val;
    },
    setNavMenuVisibility(layoutType) {
      if (
        (layoutType === 'horizontal' && this.windowWidth >= 1200) ||
        (layoutType === 'vertical' && this.windowWidth < 1200)
      ) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false);
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu');
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true);
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val;
    },
    forceRerender() {
      this.componentKey += 1;
    },
    async getOrganizationComplianceStatus() {
      const organizationId = localStorage.getItem(
        `${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`
      );
      const { data } = await this.$store.dispatch(
        'organization/fetchOrganizationDetails',
        organizationId
      );
      return data.data;
    },
    async checkClinicDrugEntry() {
      const organizationId = localStorage.getItem(
        `${process.env.VUE_APP_ACCESS_TOKEN_NAME}OrganizationId`
      );
      const { data } = await this.$store.dispatch(
        'drugbook/checkClinicDrugEntries',
        organizationId
      );

      return data.data;
    },
    isDoctorEMR() {
      return !!this.$store.state.AppActiveUser.doctorEMRClinics.length;
    },
  },
  created() {
    this.initializeIframeSettings();
    this.forceRerender();
    this.initializeNavbarSettings();

    // Dynamic Watchers for tour
    // So, watcher is required for just disabling it.
    this.dynamicWatchers.windowWidth = this.$watch(
      '$store.state.windowWidth',
      (val) => {
        if (val < 1200) {
          this.disableThemeTour = true;
          this.dynamicWatchers.windowWidth();
        }
      }
    );

    this.dynamicWatchers.verticalNavMenuWidth = this.$watch(
      '$store.state.verticalNavMenuWidth',
      () => {
        this.disableThemeTour = true;
        this.dynamicWatchers.verticalNavMenuWidth();
      }
    );

    this.dynamicWatchers.rtl = this.$watch('$vs.rtl', () => {
      this.disableThemeTour = true;
      this.dynamicWatchers.rtl();
    });
  },
  beforeDestroy() {

    Object.keys(this.dynamicWatchers).map((i) => {
      this.dynamicWatchers[i]();
      delete this.dynamicWatchers[i];
    });
  },
};
</script>
<style></style>
